import React from "react";
import {Avatar, Card, CardHeader, Typography} from "@material-ui/core";
import FlexBox from "view/components/Layout/FlexBox";

import {useTheme} from "@material-ui/core/styles";
import clsx from "clsx";
import LinkButton from "view/apps/Organiser/pages/Settings/EmbeddedShowList/components/ShowCard/LinkButton";
import TooltipTitle from "view/apps/Organiser/pages/Settings/EmbeddedShowList/components/ShowCard/TooltipTitle";
import GroupIcon from "view/images/GroupIcon";
import {CalendarToday} from "@material-ui/icons";
import {formatRange} from "tools/formats/formatDate";
import {grey} from "@material-ui/core/colors";
import {IEmbeddedShow, ShowDateFormat} from "@evennt-tech/api-v2-core";
import {AnonymousOldShow} from "ts/api/show";
import {parseISO} from "date-fns";
import ShowDetails from "./ShowDetails";
import useStyles from "./styles";

type Props = {
  show: AnonymousOldShow & {organiserLogo?: string; organiserCompany?: string};
  viewOnly?: boolean;
  isSolidCard?: boolean;
} & Pick<IEmbeddedShow, "buttonColor" | "buttonTextColor">;
const ShowCard = ({
  show,
  viewOnly = false,
  isSolidCard = false,
  buttonColor,
  buttonTextColor,
}: Props) => {
  const classes = useStyles({isSolidCard});
  const theme = useTheme();
  const {logoFile, name} = show;

  return (
    <>
      <ShowDetails show={show} isSolidCard={isSolidCard} />
      <Card className={classes.wrapper}>
        <FlexBox column height={169}>
          <FlexBox padding={1} gap={viewOnly ? 1 : 0} column={viewOnly}>
            <CardHeader
              classes={{
                root: classes.cardHeaderRoot,
                content: classes.cardHeaderContent,
              }}
              avatar={
                <Avatar
                  style={{borderRadius: theme.spacing(1)}}
                  variant="square"
                  src={logoFile?.url || ""}
                  sizes="32"
                >
                  {name.charAt(0).toUpperCase()}
                </Avatar>
              }
              title={
                <TooltipTitle
                  name={name}
                  className={clsx(
                    classes.showName,
                    !viewOnly && classes.twoLines,
                    viewOnly && classes.largeText
                  )}
                />
              }
              style={{padding: 0, maxWidth: "100%"}}
            />
          </FlexBox>
          <FlexBox column gap={1} height={169}>
            <FlexBox
              alignCenter
              className={clsx(classes.detailsView, classes.dateContainer)}
            >
              <CalendarToday htmlColor={grey[500]} className={classes.icon} />
              <Typography className={classes.detailsText}>
                {formatRange(
                  parseISO(show.liveStart),
                  parseISO(show.liveEnd),
                  ShowDateFormat.dayFirst
                )}
              </Typography>
            </FlexBox>
            {show.venueName && (
              <FlexBox alignCenter className={classes.detailsView}>
                <GroupIcon
                  fill={grey[800]}
                  className={classes.icon}
                  viewBox="0 0 8 12"
                />
                <Typography
                  className={clsx(
                    classes.detailsText,
                    classes.twoLines,
                    classes.elipsisTwoLines
                  )}
                >
                  {show.venueName}
                </Typography>
              </FlexBox>
            )}
          </FlexBox>
          {!viewOnly && (
            <LinkButton
              showId={show.id}
              buttonTextColor={buttonTextColor}
              buttonColor={buttonColor}
            />
          )}
        </FlexBox>
      </Card>
    </>
  );
};

export default ShowCard;
